<template>
  <div>
    <Row style="padding: 20px">
      <Col span="18">
        <div class="status">
          <div
            :class="['status-item', tab == '0' ? 'status-item-active' : '']"
            @click="tabNav('0')"
          >
            素材列表
          </div>
          <div
            :class="['status-item', tab == '1' ? 'status-item-active' : '']"
            @click="tabNav('1')"
          >
            素材分类
          </div>
        </div>
      </Col>
      <Col span="6">
        <Button
          v-if="tab == 0"
          type="primary"
          icon="md-add"
          class="public-fr"
          @click="openContent()"
          >添加素材</Button
        >
        <Button
          v-if="tab == 1"
          type="primary"
          icon="md-add"
          class="public-fr"
          @click="openFn()"
          >添加分类</Button
        >
      </Col>
      <Col span="24">
        <!-- 文章列表 -->
        <div v-show="tab == 0">
          <Col span="24" style="margin-bottom: 20px">
            <Select
              filterable
              v-model="params.typeCode"
              placeholder="请选择分类"
              class="public-inp"
            >
              <Option
                v-for="item in all_typeList"
                :value="item.typeCode"
                :key="item.typeCode"
                >{{ item.name }}</Option
              >
            </Select>
            <Input
              v-model="params.title"
              placeholder="请输入标题"
              class="public-inp"
            />
            <Button type="primary" icon="md-search" @click="handleSearch()"
              >搜索</Button
            >
            <Button @click="resetList()">重置</Button>
          </Col>
          <Table
            class="table"
            border
            stripe
            :loading="loading"
            :columns="columns0"
            :data="contentList.list || []"
          >
            <template slot-scope="{ index }" slot="no">
              <span>{{
                params.pageSize * (params.pageNum - 1) + index + 1
              }}</span>
            </template>
            <template slot-scope="{ row }" slot="imgUrl">
              <img
                :src="row.imageUrlView[0]"
                class="img_url"
                v-if="row.imageUrlView && row.imageUrlView.length > 0"
              />
              <span v-else>暂无</span>
            </template>
            <template slot-scope="{ row }" slot="status">
              <!-- 1=启用；2=禁用 -->
              <i-switch
                :value="row.status == 1"
                @on-change="(v) => updateState(v, row, 0)"
                size="small"
              />
            </template>
            <template slot-scope="{ row }" slot="action">
              <a
                href="javascript:;"
                @click="openContent(JSON.parse(JSON.stringify(row)))"
                >编辑</a
              >
              <a href="javascript:;" @click="removeContent(row)">删除</a>
            </template>
          </Table>
          <Page
            :style="{ float: 'right', marginTop: '10px' }"
            :total="contentList.total"
            :current.sync="params.pageNum"
            :page-size-opts="[10, 20, 30, 100]"
            :page-size="params.pageSize"
            show-sizer
            show-total
            prev-text="Previous"
            next-text="Next"
            show-elevator
            @on-change="(val) => pageNumChange(val, 'params')"
            @on-page-size-change="(val) => pageSizeChange(val, 'params')"
          />
        </div>
        <!-- 文章分类 -->
        <div v-show="tab == 1">
          <Table
            class="table"
            border
            stripe
            :loading="loading"
            :columns="columns1"
            :data="typeList.list || []"
          >
            <template slot-scope="{ index }" slot="no">
              <span>{{
                typeParams.pageSize * (typeParams.pageNum - 1) + index + 1
              }}</span>
            </template>
            <template slot-scope="{ row }" slot="status">
              <!-- 1=启用；2=禁用 -->
              <i-switch
                :value="row.status == 1"
                @on-change="(v) => updateState(v, row, 1)"
                size="small"
              />
            </template>
            <template slot-scope="{ row }" slot="action">
              <a href="javascript:;" @click="openFn(row)">编辑</a>
              <a href="javascript:;" @click="removeType(row)">删除</a>
            </template>
          </Table>
          <Page
            :style="{ float: 'right', marginTop: '10px' }"
            :total="typeList.total"
            :current.sync="typeParams.pageNum"
            :page-size-opts="[10, 20, 30, 100]"
            :page-size="typeParams.pageSize"
            show-sizer
            show-total
            prev-text="Previous"
            next-text="Next"
            show-elevator
            @on-change="(val) => pageNumChange(val, 'typeParams')"
            @on-page-size-change="(val) => pageSizeChange(val, 'typeParams')"
          />
        </div>
      </Col>
    </Row>

    <!-- 新增和编辑分类 -->
    <Modal
      v-model="typeModal"
      :title="typeTitle == 0 ? '添加分类' : '编辑分类'"
      :mask-closable="false"
      :loading="typeModalLoading"
      @on-ok="addAction"
      @on-cancel="cancelAction"
    >
      <Form
        ref="typeValidate"
        :model="typeformItem"
        :rules="ruleValidate0"
        :label-width="80"
      >
        <FormItem label="分类名称" prop="name">
          <Input
            v-model="typeformItem.name"
            placeholder="请输入分类名称"
          ></Input>
        </FormItem>
        <FormItem label="类型编码" prop="typeCode">
          <Input
            :disabled="typeTitle == 1"
            v-model="typeformItem.typeCode"
            placeholder="请输入分类类型编码"
          ></Input>
        </FormItem>
        <FormItem label="操作人" prop="operator">
          <Input
            v-model="typeformItem.operator"
            placeholder="请输入操作人"
          ></Input>
        </FormItem>
        <FormItem label="分类描述">
          <Input v-model="typeformItem.remark" type="textarea"></Input>
        </FormItem>
        <FormItem label="状态" prop="status">
          <!-- 1=启用；2=禁用 -->
          <i-switch
            :value="typeformItem.status == 1"
            @on-change="(v) => statusChange(v, 'typeformItem')"
            size="small"
          />
        </FormItem>
      </Form>
    </Modal>
    <!-- 新增和编辑文章 -->
    <Modal
      v-model="contentModal"
      :title="contentTitle == 0 ? '添加素材' : '编辑素材'"
      :mask-closable="false"
      :loading="contentModalLoading"
      @on-ok="addContent"
      @on-cancel="cancelContent"
      width="660"
    >
      <Form
        ref="contentValidate"
        :model="contentformItem"
        :rules="ruleValidate1"
        :label-width="80"
      >
        <FormItem label="文章标题" prop="title">
          <div ref="editor"></div>
        </FormItem>
        <FormItem label="所属分类" prop="typeCode">
          <Select
            v-model="contentformItem.typeCode"
            placeholder="请选择所属分类"
          >
            <Option
              :disabled="item.status == 2"
              v-for="(item, index) in all_typeList"
              :key="index"
              :value="item.typeCode"
              >{{ item.name }}</Option
            >
          </Select>
        </FormItem>
        <FormItem label="所属品牌">
          <Select
            v-model="contentformItem.brandCode"
            placeholder="请选择所属品牌"
            @on-change="brancChange"
          >
            <Option
              v-for="(item, index) in brand_list"
              :key="index"
              :value="item.code"
              >{{ item.name }}</Option
            >
          </Select>
        </FormItem>
        <FormItem label="操作人" prop="operator">
          <Input
            v-model="contentformItem.operator"
            placeholder="请输入操作人"
          ></Input>
        </FormItem>
        <FormItem label="文章描述" prop="remark">
          <Input v-model="contentformItem.remark" type="textarea"></Input>
        </FormItem>
        <FormItem label="状态" prop="status">
          <!-- 1=启用；2=禁用 -->
          <i-switch
            :value="contentformItem.status == 1"
            @on-change="(v) => statusChange(v, 'contentformItem')"
            size="small"
          />
        </FormItem>
        <FormItem label="展示门店" prop="showRetType">
          <RadioGroup v-model="contentformItem.showRetType">
            <Radio :label="1">
              <span>一般贸易门店</span>
            </Radio>
            <Radio :label="2">
              <span>保税贸易门店</span>
            </Radio>
          </RadioGroup>
        </FormItem>
        <FormItem label="生效时间" prop="validTime">
          <DatePicker
            type="datetime"
            format="yyyy-MM-dd HH:mm:ss"
            placeholder="生效开始日期"
            :value="contentformItem.startTime"
            @on-change="(v) => timeChange(v, 'startTime')"
            style="width: 48%"
          ></DatePicker>
          <DatePicker
            type="datetime"
            format="yyyy-MM-dd HH:mm:ss"
            placeholder="生效结束日期"
            :value="contentformItem.endTime"
            @on-change="(v) => timeChange(v, 'endTime')"
            style="width: 48%"
          ></DatePicker>
        </FormItem>
        <FormItem label="素材头图" prop="imgUrl">
          <Upload
            v-if="
              !contentformItem.imgUrl ||
              !contentformItem.imgUrl.length ||
              contentformItem.imgUrl.length < 9
            "
            ref="upload"
            :show-upload-list="false"
            :action="uploadUrl"
            :before-upload="beforeUpload"
            :on-success="(value) => handleSuccess(value)"
            :on-error="(value) => onError(value)"
            :format="['jpg', 'jpeg', 'png']"
            :max-size="2048000"
            :headers="{ token: $sessionToken() }"
          >
            <Button icon="ios-cloud-upload-outline" :loading="uploading"
              >上传图片</Button
            >
          </Upload>
          <!-- 图片回显 -->
          <draggable
            v-model="contentformItem.imgUrl"
            v-if="contentformItem.imgUrl && contentformItem.imgUrl.length > 0"
          >
            <transition-group>
              <div
                v-for="(img, index) in contentformItem.imgUrl"
                :key="img + index"
                class="main-image"
              >
                <img :src="img" />
                <div class="delete" @click="deleteImage(index)"></div>
              </div>
            </transition-group>
          </draggable>

          <div>
            仅支持jpg/png，图片比例为:1:1，建议尺寸：750*750,最多不超过9张
          </div>
        </FormItem>
        <FormItem label="排序号">
          <Input
            v-model="contentformItem.sort"
            placeholder="请输入文章的排序号"
          ></Input>
        </FormItem>
      </Form>
    </Modal>
  </div>
</template>

<script>
import draggable from "vuedraggable";
import axios from "axios";
import E from "wangeditor";
const columns1 = [
  {
    title: "编号",
    slot: "no",
    width: 80,
  },
  {
    title: "分类名称",
    key: "name",
  },
  {
    title: "分类编码",
    key: "typeCode",
  },
  {
    title: "操作人",
    key: "operator",
  },
  {
    title: "操作时间",
    key: "updateTime",
  },
  {
    title: "状态",
    slot: "status",
  },
  {
    title: "操作",
    slot: "action",
  },
];
const validateSelfHandler = (msg, rule, value, callback) => {
  if (new RegExp(rule).test("" + value)) {
    callback();
  } else {
    callback(new Error(msg));
  }
};
export default {
  data() {
    const columns0 = [
      {
        title: "编号",
        slot: "no",
        width: 80,
      },
      {
        title: "标题",
        key: "title",
        render(h, params) {
          let text = params.row.title;
          if (text !== null) {
            if (text.length > 20) {
              text = params.row.title.slice(0, 20) + "...";
            }
          }
          return h("div", [
            h(
              "Tooltip",
              {
                props: {
                  placement: "top",
                  transfer: true,
                },
              },
              [
                text,
                h(
                  "span",
                  {
                    slot: "content",
                    style: {
                      whiteSpace: "normal",
                    },
                  },
                  params.row.title
                ),
              ]
            ),
          ]);
        },
      },
      {
        title: "品牌",
        key: "brand",
      },
      {
        title: "描述",
        key: "remark",
      },
      {
        title: "所属分类",
        key: "typeCode",
      },
      {
        title: "图片",
        slot: "imgUrl",
        width: "100",
      },
      {
        title: "排序",
        key: "sort",
      },
      {
        title: "操作人",
        key: "operator",
      },
      {
        title: "添加时间",
        key: "createTime",
        render: (h, params) => {
          let text = this.tools.formatDate(params.row.createTime, true);
          return h("span", text);
        },
      },
      {
        title: "生效时间",
        key: "validTime",
        render: (h, params) => {
          let text = this.tools.formatDate(params.row.startTime, true),
            text0 = this.tools.formatDate(params.row.endTime, true);
          return h("span", text + "至" + text0);
        },
      },
      {
        title: "状态",
        slot: "status",
      },
      {
        title: "操作",
        slot: "action",
      },
    ];
    const validateTime = (rule, value, callback) => {
      if (!this.contentformItem.startTime || !this.contentformItem.endTime) {
        callback(new Error("生效时间不能为空"));
      } else if (
        this.contentformItem.startTime > this.contentformItem.endTime
      ) {
        callback(new Error("开始时间不能大于结束时间"));
      } else {
        callback();
      }
    };
    const validateMainImage = (rule, value, callback) => {
      if (value && value.length) {
        callback();
      } else {
        callback(new Error("素材头图不能为空"));
      }
    };

    return {
      tab: 0,
      params: {
        pageNum: 1,
        pageSize: 10,
        typeCode: "",
        title: "",
      },
      typeParams: {
        pageNum: 1,
        pageSize: 10,
      },
      contentList: {},
      typeList: {},
      loading: false,
      columns0,
      columns1,
      typeTitle: 0, //添加分类
      typeModal: false, //分类弹框
      typeformItem: {
        name: "",
        typeCode: "",
        operator: "",
        remark: "",
        status: 1,
      },
      ruleValidate0: {
        name: [
          {
            required: true,
            message: "分类名称不能为空",
            trigger: "blur",
          },
        ],
        typeCode: [
          {
            required: true,
            message: "分类编码不能为空",
            trigger: "blur",
          },
        ],
        operator: [
          {
            required: true,
            message: "操作人不能为空",
            trigger: "blur",
          },
        ],
        remark: [
          {
            required: true,
            message: "分类描述不能为空",
            trigger: "blur",
          },
        ],
        status: [
          {
            type: "number",
            required: true,
            message: "分类状态不能为空",
            trigger: "change",
          },
        ],
      },
      typeModalLoading: true,

      contentTitle: 0, //添加素材
      contentModal: false,
      contentformItem: {
        brand: "",
        brandCode: "",
        endTime: "",
        imgUrl: [],
        operator: "",
        remark: "",
        showRetType: "", //展示门店(1=一般贸易门店，2=保税贸易门店)
        sort: "", //排序号
        startTime: "",
        status: 1,
        title: "",
        typeCode: "",
      },
      ruleValidate1: {
        title: [
          {
            required: true,
            message: "文章标题不能为空",
            trigger: "blur",
          },
        ],
        typeCode: [
          {
            required: true,
            message: "所属分类不能为空",
            trigger: "change",
          },
        ],
        operator: [
          {
            required: true,
            message: "操作人不能为空",
            trigger: "blur",
          },
        ],
        remark: [
          {
            required: true,
            message: "文章描述不能为空",
            trigger: "blur",
          },
        ],
        showRetType: [
          {
            type: "number",
            required: true,
            message: "展示门店不能为空",
            trigger: "change",
          },
        ],
        status: [
          {
            type: "number",
            required: true,
            message: "分类状态不能为空",
            trigger: "change",
          },
        ],
        validTime: [
          { required: true, validator: validateTime, trigger: "blur" },
        ],
        imgUrl: [
          { required: true, trigger: "change", validator: validateMainImage },
        ],
      },
      contentModalLoading: true,
      all_typeList: [], //所有分类
      brand_list: [], //品牌
      uploadUrl: "",
      uploading: false,
      editor: null,
    };
  },
  components: {
    draggable,
  },
  mounted() {
    this.editorHandler();
  },
  created() {
    this.uploadUrl = axios.defaults.baseURL + "base/file/publicUpload";
    this.getList();
    this.getAllType();
    this.getBrandList();
  },
  methods: {
    editorHandler() {
      const self = this;
      this.editor = new E(this.$refs.editor);
      this.editor.config.customUploadImg = function (resultFiles, insertImgFn) {
        const fd = new FormData();
        fd.append("file", resultFiles[0]);
        self.$store
          .dispatch("uploadImage", fd)
          .then((res) => {
            if (res.code == 200) {
              insertImgFn(res.data.url);
            } else {
              self.$Message.error("图片上传失败");
            }
          })
          .catch((err) => {
            self.$Message.error("图片上传失败");
          });
      };
      // 配置 onchange 回调函数
      this.editor.config.onchange = function (newHtml) {
        self.contentformItem.title = newHtml;
      };
      // 配置触发 onchange 的时间频率，默认为 200ms
      this.editor.config.onchangeTimeout = 500;
      this.editor.create();
      this.editor.txt.html(this.contentformItem.title); // 重新设置编辑器内容
    },
    brancChange(e) {
      if (e) {
        let brandName = this.brand_list.filter((item) => item.code == e)[0]
          .name;
        this.contentformItem.brand = brandName;
      }
    },

    getBrandList() {
      this.$api.brandAll().then((res) => {
        if (res.code == 200) {
          this.brand_list = res.data;
        }
      });
    },

    getAllType() {
      this.$api.maTypeList({ pageNum: 1, pageSize: 99999 }).then((res) => {
        if (res.code == 200) {
          this.all_typeList = res.data.list;
        }
      });
    },
    openFn(d) {
      this.typeTitle = d ? 1 : 0;
      if (d) {
        Object.keys(this.typeformItem).forEach((key) => {
          this.typeformItem[key] = d[key];
        });
        this.typeformItem.id = d.id;
      }
      this.$nextTick(() => {
        this.typeModal = true;
      });
    },
    tabNav(e) {
      this.tab = e;
      let d = e == 0 ? "params" : "typeParams";
      this[d].pageNum = 1;
      this[d].pageSize = 10;
      this.getList();
    },
    handleSearch() {
      this.params.pageNum = 1;
      this.params.pageSize = 10;
      this.getList();
    },
    getList() {
      this.loading = true;
      let params = {};
      if (this.tab == 0) {
        params = this.params;
        this.$api
          .materialList(params)
          .then((res) => {
            if (res.code == 200) {
              this.getAllType();
              this.loading = false;
              this.contentList = res.data;
            }
          })
          .finally((err) => {
            this.loading = false;
          });
      } else {
        params = this.typeParams;
        this.$api
          .maTypeList(params)
          .then((res) => {
            if (res.code == 200) {
              this.loading = false;
              this.typeList = res.data;
            }
          })
          .finally((err) => {
            this.loading = false;
          });
      }
    },

    // 页码
    pageNumChange(pageNum, tab) {
      this[tab].pageNum = pageNum;
      this.getList();
    },
    // 页数
    pageSizeChange(pageSize, tab) {
      this[tab].pageSize = pageSize;
      if (this[tab].pageNum == 1) {
        this.getList();
      } else {
        this[tab].pageNum = 1;
      }
    },
    // 分类新增和编辑
    addAction() {
      this.typeModalLoading = false;
      this.$nextTick(() => {
        this.typeModalLoading = true;
      });
      let data = { ...this.typeformItem };
      let http = "maTypeAdd";
      this.$refs["typeValidate"].validate((valid) => {
        if (valid) {
          if (this.typeTitle == 1) {
            http = "maTypeUpt";
          }
          this.$api[http](data).then((res) => {
            if (res.code == "200") {
              this.$Message.success("操作成功");
              this.cancelAction();
              this.getList();
            }
          });
        }
      });
    },
    //分类的取消按钮
    cancelAction() {
      Object.keys(this.typeformItem).forEach((key) => {
        this.typeformItem[key] = "";
      });
      this.$refs["typeValidate"].resetFields();
      this.typeModal = false;
    },
    openContent(d) {
      this.contentTitle = d ? 1 : 0;
      if (d) {
        Object.keys(this.contentformItem).forEach((key) => {
          this.contentformItem[key] = d[key];
        });
        this.contentformItem.id = d.id;
        this.contentformItem.imgUrl = d.imageUrlView;
        if (this.editor) {
          this.editor.txt.html(this.contentformItem.title);
        }
      } else {
        this.contentformItem.imgUrl = [];
      }
      this.$nextTick(() => {
        this.contentModal = true;
      });
    },
    addContent() {
      this.contentModalLoading = false;
      this.$nextTick(() => {
        this.contentModalLoading = true;
      });
      let data = { ...this.contentformItem };
      let http = "materialAdd";
      this.$refs["contentValidate"].validate((valid) => {
        if (valid) {
          if (this.contentTitle == 1) {
            http = "materialUpt";
            data.startTime = this.tools.formatDate(data.startTime, true);
            data.endTime = this.tools.formatDate(data.endTime, true);
          }
          this.$api[http](data).then((res) => {
            if (res.code == "200") {
              this.$Message.success("操作成功");
              this.cancelContent();
              this.getList();
            }
          });
        }
      });
    },
    // 弹框取消
    cancelContent() {
      Object.keys(this.contentformItem).forEach((key) => {
        this.contentformItem[key] = "";
      });
      if (this.editor) {
        this.editor.txt.html(this.contentformItem.title);
      }
      this.$refs["contentValidate"].resetFields();
      this.contentModal = false;
    },
    // 分类删除
    removeType(row) {
      let id = row.id;
      this.$Modal.confirm({
        title: "提示",
        content: `确认删除该分类吗`,
        okText: "确定",
        cancelText: "取消",
        onOk: async () => {
          this.$api
            .maTypeDel({ id: id })
            .then((res) => {
              if (res.code == 200) {
                this.$Message.success("删除成功");
                this.getList();
              } else {
                this.$Message.error("删除失败");
              }
            })
            .catch((err) => {
              this.$Message.error(res.message);
            });
        },
      });
    },
    // 素材删除
    removeContent(row) {
      let id = row.id;
      this.$Modal.confirm({
        title: "提示",
        content: `确认删除该文章吗`,
        okText: "确定",
        cancelText: "取消",
        onOk: async () => {
          this.$api
            .materialDel({ id: id })
            .then((res) => {
              if (res.code == 200) {
                this.$Message.success("删除成功");
                this.getList();
              } else {
                this.$Message.error("删除失败");
              }
            })
            .catch((err) => {
              this.$Message.error(res.message);
            });
        },
      });
    },
    // 修改状态
    statusChange(e, tab) {
      this[tab].status = e ? 1 : 2;
    },
    updateState(v, d, tab) {
      d.status = v ? 1 : 2;
      delete d.createTime;
      delete d.updateTime;
      d.imgUrl = d.imageUrlView;
      if (tab == 0) {
        d.startTime = this.tools.formatDate(d.startTime, true);
        d.endTime = this.tools.formatDate(d.endTime, true);
      }
      let http = tab == 0 ? "materialUpt" : "maTypeUpt";
      this.$api[http](d).then((res) => {
        if (res.code == "200") {
          this.$Message.success(v ? "启用成功" : "禁用成功");
          this.getList();
        }
      });
    },
    resetList() {
      this.params.pageNum = 1;
      this.params.pageSize = 10;
      this.params.typeCode = "";
      this.params.title = "";
      this.$nextTick(() => {
        this.getList();
      });
    },
    timeChange(v, type) {
      this.contentformItem[type] = v;
    },
    beforeUpload(d) {
      let size = d.size;
      let type = d.type;
      if (size > 2048000) {
        this.$Message.error("图片不可大于2M");
        return false;
      }
      if (type != "image/png" && type != "image/jpg" && type != "image/jpeg") {
        this.$Message.error("仅支持jpg/png");
        return false;
      }
      this.uploading = true;
    },

    handleSuccess(value) {
      this.uploading = false;
      let data = value.data;
      if (this.contentformItem.imgUrl == undefined) {
        this.contentformItem.imgUrl = [];
      } else {
        this.contentformItem.imgUrl.push(data.url);
      }
    },
    onError(value) {
      this.contentformItem.imgUrl = "";
      this.uploading = false;
      this.$Message.error("上传失败");
    },

    deleteImage(index) {
      this.contentformItem.imgUrl.splice(index, 1);
    },
  },
};
</script>

<style scoped>
.status {
  max-width: 40%;
  display: flex;
  margin-bottom: 15px;
}

.status .status-item {
  width: 100px;
  text-align: center;
  height: 32px;
  line-height: 30px;
  font-size: 12px;
  padding: 0 20px;
  cursor: pointer;
  user-select: none;
  transition: 0.25s;
  outline: none;
  background-color: #fff;
  color: #5586ff;
  border: 1px solid #5586ff;
  white-space: nowrap;
}

.status .status-item:first-child {
  border-radius: 4px 0 0 4px;
}

.status .status-item:last-child {
  border-radius: 0 4px 4px 0;
}

.status .status-item:not(:first-child) {
  margin-left: -1px;
}

.status .status-item-active {
  color: #fff;
  border-color: #5586ff;
  background-color: #5586ff;
}
.table {
  margin-top: 10px;
}
.img_url {
  width: 50px;
  height: 50px;
  margin: 10px;
  border-radius: 5px;
}
.main-image {
  position: relative;
  display: inline-block;
  width: 60px;
  height: 60px;
  border-radius: 4px;
  background-color: #f8f9fa;
  border: 1px solid #dcdfe6;
  margin-right: 20px;
  margin-top: 10px;
  overflow: hidden;
}

.main-image img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}

.main-image .delete {
  display: none;
  position: absolute;
  height: 20px;
  text-align: center;
  bottom: 0;
  left: 0;
  right: 0;
  background: rgba(0, 0, 0, 0.6);
}

.main-image .delete::after {
  content: " ";

  display: inline-block;
  height: 20px;
  width: 14px;
  background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAMgAAADICAYAAACtWK6eAAANWklEQVR4Xu2dXahtVRmG3/dClBNkaETJsR84WlT+ZJKJBmo/aqVkRyPQC7OUiIwUUq9Sb0oNFFT60cou9EazTM0ytYw0lTJLEzpmZP5QRB7qQKZ08cWotelw2Gutd8wx1txjzvlOOJyL/X3fGOP55jvetfeaP4QPEzCBuQRoNiZgAvMJWCA+O0xgAQELxKeHCVggPgdMoBsBO0g3bs6aCAELZCKN9jK7EbBAunFz1kQIWCATabSX2Y2ABdKNm7MmQsACmUijvcxuBCyQbtycNRECFshEGu1ldiNggXTj5qyJELBAJtJoL7MbAQukGzdnTYSABbJLoyPijQDSvzcB2DSR8+AFAL8DsI3ktomsWVrm5AUSEa8HcBSA9wM4RaI2/qCbANwB4F6ST41/ufNXOFmBRMQWAJ8BcPaUTwBh7VcBuJLkk0Ls6EImKZCIuGgmjL1G19HVLGj7TCQXr6Z8u1UnJ5CI+CGAY9ttSdMzu5PkcU3PsPLkJiWQiPgHgJdXZji1cjtI7jmVRU9GIBFxF4D3TKWxK17n3STfu+Ixmig/CYFExCUAzm+C+HgmcSnJC8aznPVXMnqBRMSHAdw89kZu0Pq2kvzOBo3dy7BTEMhPZt9zKEDvBPAAgAfT/yR3KElDj4mIzQAOn/07BsBB4prS9yRHi7GDDBu1QCLiEwCuFTtzGcnJfwyLiN0BfBnAGSK3M0l+XYwdXNjYBZK+DT5e6Mobpv6N8a6MImI/AE8I7H5AMl2FMMpjtAKJiPQl4PNC144keb8QN7mQiDgCwH3Cwvcmmb5MHN0xZoGcCuD6JR3zx6olgCLiUgDnLQk7jeQNo1MHgDELJF1D9OklTTuQ5GNjbGytNUXEAQAeXVLvapKjvKZtzAL5EYBFX2Y9Q/K1tU6kMdeJiKcB7LtgjXeRfN8YGYxZIH8CsEgAt5A8aYxNrb2miPgugA8tqPs0ydfVHreFemMWSCwBfDHJdFWvj+W/hyROFy4KIznKc2mUi0qNjAgLpJL0Z7cHWCCVeDZRxgKp1wYLpB7LZipZIPVaYYHUY9lMJQukXisskHosm6lkgdRrhQVSj2UzlSyQeq2wQOqxbKaSBVKvFRZIPZbNVLJA6rXCAqnHsplKFki9Vlgg9Vg2U8kCqdcKC6Qey2YqWSD1WmGBVGIZEa8CkC5ae1mlkiVl0r3oi470lMB7SwaYUG56dvHCS00AtHBv+nMA0oWTL9XqTbVrsSLiKwA+WWtirmMCHQn8Id0HRDI9QbP4qCIQ8a6z4sm6gAmIBP4GIN1KXfwqh2KBzF4f8Edx4g4zgb4IXEUyPb2/6KghkNMBXFc0CyebQH0CT5JMT2YpOmoIJL105saiWTjZBOoTeJzkW0vL1hBIeirfM6UTcb4JVCZwBclzS2sWCyRNwL+kl7bB+ZUJtPNL+trCIuJyAOdUXqjLmUAugfQ0yE+RvCc3cb34Kg6yk0heDSC9FHOPGpNzDRPIJPAXAE+RfDEzb254VYHUmpTrmEArBCyQVjrheTRJwAJpsi2eVCsELJBWOuF5NEnAAmmyLZ5UKwQskFY64Xk0ScACabItnlQrBCyQVjrheTRJwAJpsi2eVCsELJBWOuF5NEnAAmmyLZ5UKwQGJ5CIeDOA9BCBdO/xAyR39A0zIl4xm8Nuszk82/ccPF4/BAYlkIhITypJ4lg70rvzvkTy6n5w/ffS/vS2pTMB7LPTmNcA+GJL71qPiHQj27EATgTwOICfAkhv9X2hR1abAHxu1rP9ZzfWfbXGveJ9rWEwAomIKwHMe5PqGSRXfttvRHwWwBVzmvMtkh/rq3GLxomI4wHcsU7MIwCOI/nXVc9z9gio9GSRt+0yVrpX46O1Lkdf9ToGIZCIOBhAau684xGSh6waVkT8ap2G7zzsa0imS6437Jh9/PsFgC1zJnEzyZNXPcGI+DaArXPGSfdsHELyn6ueR2n9oQhk0c6dGLxAcuUPq4uI1ND0sWHecTjJB0ubUpIfEelttOmttPOOXt5IGxHL3jL8DpJJyE0fQxFIE29ZFR5nejTJDX1aYyuPCR0CK0WZFohCaRYzhKZbIBkNFUItEAHSWogFosMaAitlNRaIQskOkkHpf6EWSDay7gn+2KCzMyudlRJpB1Eo2UEyKNlBsmGVJnhX1Amalc5KibSDKJTsIBmU7CDZsEoTvCvqBM1KZ6VE2kEUSnaQDEp2kGxYpQneFXWCZqWzUiLtIAolO0gGJTtINqzSBO+KOkGz0lkpkXYQhZIdJIOSHSQbVmmCd0WdoFnprJRIO4hCyQ6SQckOkg2rNMG7ok7QrHRWSqQdRKFkB8mgZAfJhlWa4F1RJ2hWOisl0g6iULKDZFCyg2TDKk3wrqgTNCudlRJpB1Eo2UEyKNlBsmGVJnhX1Amalc5KibSDKJTsIBmU7CDZsEoTvCvqBM1KZ6VE2kEUSnaQDEp2kGxYpQneFXWCZqWzUiLtIAolO0gGJTtINqzSBO+KOkGz0lkpkXYQhZIdJIOSHSQbVmmCd0WdoFnprJRIO4hCyQ6SQckOkg2rNMG7ok7QrHRWSqQdRKFkB8mgZAfJhlWa4F1RJ2hWOisl0g6iULKDZFCyg2TDKk3wrqgTNCudlRJpB1Eo2UEyKNlBsmGVJnhX1Amalc5KibSDKJTsIBmU7CDZsEoTvCvqBM1KZ6VE2kEUSnaQDEp2kGxYpQneFXWCZqWzUiLtIAolO0gGJTtINqzSBO+KOkGz0lkpkXYQhZIdJIOSHSQbVmmCd0WdoFnprJRIO4hCyQ6SQckOkg2rNMG7ok7QrHRWSqQdRKFkB8mgZAfJhlWa4F1RJ2hWOisl0g6iULKDZFCyg2TDKk3wrqgTNCudlRJpB1Eo2UEyKNlBsmGVJnhX1Amalc5KibSDKJTsIBmU7CDZsEoTvCvqBM1KZ6VE2kEUSnaQDEp2kGxYpQneFXWCZqWzUiLtIAolO0gGJTtINqzSBO+KOkGz0lkpkXYQhZIdJIOSHSQbVmmCd0WdoFnprJRIO4hCyQ6SQckOkg2rNMG7ok7QrHRWSqQdRKFkB8mgZAfJhlWa4F1RJ2hWOisl0g6iUPq/g/wWwFsWpOxD8s8ZJauHRsThAH6+oPDDJA+tPvAuBSMiloxxNMl7Vz2P0voWSAbBiLgOwOlzUh4i+c6McisLjYhfAnj7nAEuInnxygYf0MdRhYEFolDaKSYi1nORpwCcTPLhzHIrCY+IswB8bZ3it5A8aSWD2kH6wLr+GK18rl6bXURcCOBAADsA3E3yho2jM5fZUQC2AtgC4O8AtpG8qK95+iNWX6QBtCaQHpc+2KEskB5bZ4H0CLvSUBZIJZBKGQtEodRWjAXSYz8skB5hVxrKAqkEUiljgSiU2oqxQHrshwXSI+xKQ1kglUAqZSwQhVJbMRZIj/2wQHqEXWkoC6QSSKWMBaJQaivGAumxHxZIj7ArDWWBVAKplLFAFEptxVggPfbDAukRdqWhLJBKIJUyFohCqa0YC6THflggPcKuNJQFUgmkUsYCUSi1FWOB9NgPC6RH2JWGskAqgVTKWCAKpbZiLJAe+2GB9Ai70lAWSCWQShkLRKHUVowF0mM/LJAeYVcaygKpBFIpY4EolNqKsUB67IcF0iPsSkNZIJVAKmUsEIVSWzEWSI/9sEB6hF1pKAukEkiljAWiUGorxgLpsR8RcSqA65cMuS/JZ3ucloeaQyAiNgN4Zgmgg0g+2jrEoTyb9zAADy6B+RGSN7UOfArzi4hTANy4ZK2bST7XOo+hCGQvAM8vgXkFyXNbBz6F+UXE5QDOWbLWTST/1TqPQQgkQYyI38weGD2Pafr5YSRfah36mOcXEbsDeAjAQQvW+SjJRT9vBtGQBHI+gEuWkPsmyY83Q3eCE4mIbwA4Y8nSLyB56RDwDEkg6YUw6cUwy479Sf5+WZB/Xp9AROwH4Amh8qGtvEtl2VwHI5DZx6xbAZywbFEAjiR5vxDnkEoEIuIIAPcJ5W4jeaIQ10TI0ATyQQC3ieQuS38aJvmYGO+wDgQi4gAApwE4T0w/geTtYuyGhw1KIJkusgY3/T0+vRot/RLvox6B9Et2+ti7b0bJQblHWtcQBfIuAPcA2C2jMQ7deAL/BvBukj/b+KnoMxicQGYuciaAa/RlOrIBAmeRvLaBeWRNYZACmYkkvZAyvUzTR/sEenn19CowDFYgM5EcA+D7APZYBRzXLCbwIoAPkPxxcaUNKjBogcxEcjCALwA4foMYetj1CaS/Nn6e5K+HDGjwAlmDP7vi9+x0ucmQGzKCuSdhXDOkP+UuYj4agewklOQka/+2jOCEG8IStgH4HoBbx/YF7egEsvPZFBGbAOwN4JUA9hzCmTagOW6fXWG9fQhX5XblOmqBdIXiPBNYI2CB+FwwgQUELBCfHiZggfgcMIFuBOwg3bg5ayIELJCJNNrL7EbAAunGzVkTIWCBTKTRXmY3AhZIN27OmggBC2QijfYyuxGwQLpxc9ZECFggE2m0l9mNgAXSjZuzJkLAAplIo73MbgQskG7cnDURAhbIRBrtZXYj8B/KIAFBv9qf9AAAAABJRU5ErkJggg==);
  background-position: center;
  background-size: contain;
  background-repeat: no-repeat;
}

.main-image:hover .delete {
  display: block;
}
</style>


// WEBPACK FOOTER //
// src/views/content/materialList.vue